import router from '@/router';
import store from '@/store'; // Importar o store

export function getUserDetails() {
  return localStorage.getItem('user');
}

export function setUserDetails(userDetail) {
  localStorage.setItem('user', userDetail);
}

export async function signOut() {
  try {
    // Limpar cache MSAL ANTES de limpar localStorage
    if (window.$msal) {
      try {
        // Limpar todas as contas do MSAL
        const accounts = window.$msal.getAllAccounts();
        if (accounts.length > 0) {
          // Fazer logout do Microsoft Entra ID usando redirect
          try {
            await window.$msal.logoutRedirect({
              postLogoutRedirectUri: '/login',
            });
            // Redirect não retorna - a página é redirecionada imediatamente
            // O código abaixo não será executado
            return;
          } catch (logoutError) {
            // Se o logoutRedirect falhar, tentar apenas limpar o cache
            if (window.$swal) {
              window.$swal.fire({
                title: 'Aviso no Logout',
                html: 'Ocorreu um erro ao fazer logout do Microsoft Entra ID. <br/> O cache será limpo mesmo assim.',
                icon: 'warning',
                confirmButtonText: 'Ok',
                timer: 3000,
                timerProgressBar: true,
              });
            }
          }
        }
        // Limpar cache MSAL
        await window.$msal.clearCache();
      } catch (error) {
        // Continuar mesmo se houver erro
        if (window.$swal) {
          window.$swal.fire({
            title: 'Aviso no Logout',
            html: 'Ocorreu um erro ao limpar o cache MSAL. <br/> Você será redirecionado para o login mesmo assim.',
            icon: 'warning',
            confirmButtonText: 'Ok',
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }
    }
  } catch (error) {
    // Mostrar modal de erro para o usuário
    if (window.$swal) {
      window.$swal.fire({
        title: 'Erro no Logout',
        html: 'Ocorreu um erro ao fazer logout do Microsoft Entra ID. <br/> Você será redirecionado para o login mesmo assim.',
        icon: 'warning',
        confirmButtonText: 'Ok',
      });
    }
  }

  // Limpar dados locais COMPLETAMENTE (após limpar cache MSAL)
  localStorage.clear();
  sessionStorage.clear(); // Limpar também sessionStorage

  // Limpar todos os cookies
  document.cookie.split(';').forEach((c) => {
    document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=Thu, 01 Jan 1970 00:00:00 GMT ;path=/');
  });

  // Limpar store do Vuex (importante para o Vuex Persist)
  store.commit('setCompanyData', {});
  store.commit('setCompanyName', '');
  store.commit('setUserId', '');

  // Redirecionar para login
  window.location.href = router.resolve({ name: 'login' }).href;
}
